import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FormControl, FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {MatDialogRef} from '@angular/material/dialog';
import {ICellEditorAngularComp} from 'ag-grid-angular';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-obsolete',
  templateUrl: './obsolete.component.html',
  styleUrls: ['./obsolete.component.scss']
})
export class ObsoleteComponent implements ICellEditorAngularComp, OnInit {
  private params: any;
  public replacementProduct: any;
  @ViewChild('skuSearch') searchElement: ElementRef | undefined;
  public form = new FormGroup({
    _id: new FormControl(),
    sku: new FormControl({
      _id: undefined,
      sku: undefined
    }),
    type: new FormControl('')
  });
  filteredOptions: any;
  showSearch: boolean = false;
  saved: boolean = false;
  currentFilter: string = 'Equals';

  public selectSkuId: any;
  public selectSkuName: any;

  selectValues: any = [
    {value: '', viewValue: 'false'},
    {value: 'sku', viewValue: 'Has replacement SKU'},
    {value: 'noReplacement', viewValue: 'true'},
  ];

  constructor(
    private http: HttpClient,
  ) { }

  ngOnInit(): void {}

  displayFn = (data: any) => {
    console.log('displayFn 🔴', data);
    console.log('this.showSearch', this.showSearch);
    this.replacementProduct = data;

    if (data) {
      if (data.sku === 'Obsolete / NO replacement') {
        return '';
      } else {
        this.selectSkuId = data._id;
        this.selectSkuName = data.sku;
        return data.sku;
      }
    } else {
      return '';
    }
  }

  changeType(): void {
    console.log('changeType', this.form.get('type')?.value);
    if (this.form.get('type')?.value === 'sku') {
      this.showSearch = true;
    } else {
      this.showSearch = false;
    }
  }

  save(): any {
    console.log('save');
    if (this.form.get('type')?.value === 'sku' && this.selectSkuId === undefined) {
      return false;
    }
    this.saved = true;
    this.form.get('sku')?.setValue({
      _id: this.selectSkuId,
      sku: this.selectSkuName
    });
    console.log('this.params.api', this.params.api);
    this.params.api.stopEditing();
  }

  changeFilterType(type: string): void {
    this.currentFilter = type;
    this.onChange(null);
    setTimeout(() => {
      // @ts-ignore
      this.searchElement.nativeElement.focus();
    }, 300);
  }
  onChange($event: any): void {
    this.filteredOptions = this.http.post(environment.API_PATH + '/product/stage/search', {
      // sku: $event.target.value,
      sku: this.form.get('sku')?.value,
      type: this.currentFilter
    });
    // console.log('---', this.form.get('sku')?.value);
    // console.log('onChange', $event.target.value);
  }

  getValue(): any {
    console.log('🎃', this.params);
    if (this.saved) {
      this.saved = false;
      if (this.form.get('type')?.value === 'sku') {
        console.log('1');
        return {
          obsolete: true,
          _id: this.selectSkuId,
          sku: this.selectSkuName,
        };
      } else if (this.form.get('type')?.value === 'noReplacement') {
        console.log('2');
        return {
          obsolete: true,
          _id: undefined,
          sku: undefined,
        };
      } else {
        console.log('3');
        return {
          obsolete: false,
          _id: undefined,
          sku: undefined,
        };
      }
    } else {
      return this.params.data.replacement;
    }
  }

  isPopup(): boolean {
    return false;
  }

  agInit(params: any): void {
    console.log('agInit', params);
    this.params = params;
    if (params.data?.replacement?.obsolete && params.data?.replacement?._id) {
      this.showSearch = true;
      this.form.get('type')?.setValue('sku');
      this.form.get('sku')?.setValue({
        _id: params.value._id,
        sku: params.value.sku
      });
    } else if (params.data?.replacement?.obsolete && params.data?.replacement?._id === undefined) {
      this.showSearch = false;
      this.form.get('type')?.setValue('noReplacement');
    } else {
      this.form.get('type')?.setValue('');
      this.showSearch = false;
    }
  }
}
